/**
 * @file noteTags.ts
 * @brief Tag limits and clean-up shared by the tag editor and TagsMenu
 *        (moved out of NoteTagsEditor.tsx 04-10-2026 so that file keeps its
 *        Fast Refresh: it exports components only).
 *
 * @author DES
 * @date 04-10-2026
 */

// ----------------------------------------------------------------------
// Limits — keep in lockstep with BACKEND/src/features/notes/noteTags.mjs
// ----------------------------------------------------------------------
export const MAX_NOTE_TAGS = 12;
export const MAX_NOTE_TAG_LENGTH = 40;

export function normalizeTag(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, " ");
}

export function parseTagInput(raw: string): string[] {
  return raw
    .split(/[,#]+/)
    .map(normalizeTag)
    .filter(Boolean);
}

export function mergeTags(existing: string[], incoming: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const tag of [...existing, ...incoming]) {
    const n = normalizeTag(tag);
    if (!n || n.length > MAX_NOTE_TAG_LENGTH || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
    if (out.length >= MAX_NOTE_TAGS) break;
  }
  return out;
}

